//export const MY_API = process.env.REACT_APP_MY_API || "http://localhost:3001"
export const MY_API = "https://foodtier.onrender.com"